import { KeySellingPoint } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getKSP = async (familyId: string, locale: string): Promise<KeySellingPoint[]> => {
  const url = `/family/${familyId}/keysellingpoints?include=available&marketLocale=${locale}&kspMode=short`;
  const response = await productCatalogueHttp.get<KeySellingPoint[]>(url);
  return response.data;
};
